import { MetaData } from '../../models';
import { RouteKeys } from './route-keys';

export const metaData: MetaData = {
  title: 'Subscription Plans',
  resource: 'admin-subscription-plan',
  source: 'data.data',
  route: RouteKeys.List,
  paginate: true,
  perPage: 10,
  page: 1,
};
